import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
export default function GourmetOnTheGo() {
  return <section data-section-id="233563" id="fedezze-fel-a-világot" className="dark relative flex min-h-[100svh] w-full items-center overflow-hidden bg-background text-foreground">
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/breathtaking_mountain_landscape_horizon.png" alt="Breathtaking mountain landscape at sunrise" className="h-full w-full object-cover object-center opacity-80" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/breathtaking_mountain_landscape_horizon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/breathtaking_mountain_landscape_horizon.png-wvc-sizes" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/40 via-primary/20 to-transparent" />
        <div className="absolute inset-0 bg-background/30 backdrop-blur-[1px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl space-y-8">
          <h1 className="font-default text-5xl font-bold leading-[1.1] tracking-tighter text-foreground sm:text-6xl md:text-7xl lg:text-8xl">Sly‑Go</h1>
          <h1 className="font-default text-5xl font-bold leading-[1.1] tracking-tighter text-foreground sm:text-6xl md:text-7xl lg:text-8xl">
            <span className="block">A világ csak</span>
            <span className="block mt-2">Önre vár.</span>
          </h1>

          <p className="font-default text-lg leading-relaxed text-muted-foreground md:text-xl md:max-w-xl">
            Foglaljon szállást, repülőjegyet és transzfert másodpercek alatt. Következő kalandja csak egy kattintásra van modern foglalási rendszerünkben.
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center opacity-70">
        <span className="mb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
          Görgessen
        </span>
        <ChevronDown className="size-5 animate-bounce text-primary" />
      </div>
    </section>;
}